<script setup>
// Component props
const componentProps = defineProps({
  persistent: {
    type: Boolean,
    required: false,
    default: false,
  },
  seamless: {
    type: Boolean,
    required: false,
    default: false,
  },
})

// Models
const showDialog = defineModel('show', { type: Boolean, required: true })
</script>

<template>
  <q-dialog :seamless="seamless" :persistent="persistent" class="mobile" v-model="showDialog" position="bottom" square full-width>
    <q-card class="full-width bg-transparent" flat>
      <q-card-section class="q-pa-none full-width bg-transparent">
        <div class="row bg-transparent" v-if="persistent || seamless">
          <div class="col-12 q-pa-xs flex justify-end">
            <q-btn dense color="negative" size="sm" icon="clear" @click="showDialog = !showDialog" />
          </div>
        </div>
        <div class="row buttons-container bg-white">
          <div class="col-12 q-pa-xs q-my-auto">
            <slot></slot>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped></style>
